import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnCheckboxGroupComponent} from './checkbox-group.component';
import {FormsModule} from '@angular/forms';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';


@NgModule({
  declarations: [GnCheckboxGroupComponent],
  imports: [
    CommonModule,
    FormsModule,
    NzCheckboxModule,
  ],
  exports: [GnCheckboxGroupComponent],
  entryComponents: []
})
export class GnCheckboxGroupModule {
}
